// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryConfig from "../app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CountryRepoManager from "../app/repo/CountryRepoManager.bs.js";
import * as Timestamp$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function useCountryConfig(param) {
  var match = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var updateCountryConfig = match[1];
  var RepoInstance = CountryRepoManager.getRepo(undefined);
  var $$fetch = function (param) {
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._1(RepoInstance.fetchCountryConfig, undefined);
                }), (function (data) {
                  return Curry._1(updateCountryConfig, (function (param) {
                                Timestamp$Catalyst.setTz(CountryConfig.getTimezone(data));
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(updateCountryConfig, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
  };
  React.useEffect((function () {
          $$fetch(undefined);
          
        }), []);
  return match[0];
}

export {
  useCountryConfig ,
  
}
/* react Not a pure module */
